import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_ReceiptDt: new Date(), // dd/MM/yyyy
    A_Loc: "",
    A_LocName: "",
    A_DocStat: "ENTER",
    Truck: "",
    Driver: "",
  },
};

const SliceOutletPlanningReport = createSlice({
  name: "SliceOutletPlanningReport",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_OutletPlanningReport_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_OutletPlanningReport_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_OutletPlanningReport_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
  },
});

export const {
  Set_OutletPlanningReport_Init,
  Set_OutletPlanningReport_HeadObject_Set,
  Set_OutletPlanningReport_HeadObject_Init,
} = SliceOutletPlanningReport.actions;
export default SliceOutletPlanningReport.reducer;
